import React from 'react';
import './Aboutme.css';
import star from '../../assets/stars 1.svg';
import headphone from '../../assets/headphones 1.svg';
import pack from '../../assets/package.svg';
import truck from '../../assets/delivery-truck 1.svg';
import leaf from '../../assets/leaf 2.svg';
import shop from '../../assets/shopping-bag.svg';
// import containpic from '../../assets/man.png';
import containpic from '../../assets/Aboutimage/full-shot-smiley-women-working.jpg';
// import containpic from '../../assets/Aboutimage/167627f9-e191-4e4f-a044-0e740fcb3de7 1.jpeg';



const AboutMeSection = () => {
  return (
    <section className="about-me-section container-fluid position-relative pt-4">
      {/* Background Images with subtle animations */}
      <div
        // className="bg-image-1" 
        data-aos="fade"
        data-aos-delay="300"
        data-aos-duration="1500"
      />
      <div
        // className="bg-image-2" 
        data-aos="fade"
        data-aos-delay="500"
        data-aos-duration="1500"
      />

      <div className="row align-items-center justify-content-around">
        {/* Left Image with creative animation */}
        <div className="col-md-5 col-sm-12">
          <img
            src={containpic}
            className='contain-img'
            data-aos="custom-slide"
            data-aos-delay="200"
            data-aos-duration="800"
            data-aos-easing="ease-out-back"
            data-aos-anchor-placement="center-bottom"
            style={{ borderRadius: "20px" }}
          />
        </div>

        {/* Right Content with staggered animations */}
        <div
          className="col-md-6 text-content p-4 col-sm-12 organic-row-bg"
          data-aos="fade-left"
          data-aos-duration="800"
        >
          <h2
            className="about-me-heading mb-3"
            data-aos="text-focus-in"
            data-aos-delay="300"
            data-aos-duration="1000"
          >
            Our Commitment to Quality and Sustainability
          </h2>
          <p
            className="about-me-description"
            data-aos="fade-up"
            data-aos-delay="500"
            data-aos-duration="600"
          >
            We don't just sell products. We deliver exceptional shopping experiences that prioritize quality, convenience, and customer satisfaction. From browsing to delivery, every step is optimized to ensure seamless transactions, secure payments, and timely fulfillment for our valued customers.          </p>

          {/* Feature Boxes with dynamic staggered animations */}
          <div className="row mt-5">
            {[
              { img: leaf, title: "Quality Products", subtitle: "Seller lists products with detailed descriptions, images, pricing, and inventory" },
              { img: star, title: "Customer Feedback", subtitle: "Verified buyers browse, compare, and place orders" },
              { img: truck, title: "Fast Delivery", subtitle: "Quick and reliable shipping with tracking" },
              { img: headphone, title: "Great Support 24/7", subtitle: "Orders confirmed; logistics coordinated with reliable delivery partners" },
              // { img: shop, title: "100% Secure Payment", subtitle: "We ensure your money is safe" },
              // { img: pack, title: "Organic Packaging", subtitle: "Farmer receives payment securely " }
            ].map((feature, i) => (
              <div
                className="mb-3 col-md-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6"
                key={i}
                data-aos="flip-up"
                data-aos-delay={100 * (i + 3)}
                data-aos-duration="600"
              >
                <div className="d-flex align-items-center ">
                  <div
                    className="icon-box me-3"
                    data-aos="zoom-in"
                    data-aos-delay={100 * (i + 4)}
                    data-aos-duration="400"
                  >
                    {/* <img src={feature.img} alt="icon" width="40" /> */}
                  </div>
                  <div>
                    {/* <div className="fw-bold">{feature.title}</div> */}
                    <div className="text-muted small">{feature.subtitle}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMeSection;
